import React from "react";
import './addons-status.scss';
import {AddonsStatusesLabelColorsMap, AddonStatuses, AddonStore} from "../../../../stores/addons-store-list";
import {Badge} from "../../../../../../../components/badge/badge";
import subscriptionPlansStore from "../../../../../../subscription-plans/stores/subscription-plans-store";

const AddonStatus: React.FC<{ addon: AddonStore }> = ({addon}) => {

    let quotaFromPlan, quotaFromAddon = 0;
    if (addon.isQuotaBased()) {
        quotaFromPlan = subscriptionPlansStore.userPlan?.getQuotaFromPlan(addon.getQuotaBasedFeatureId());
        quotaFromAddon = subscriptionPlansStore.userPlan?.getQuotaFromAddon(addon.getQuotaBasedFeatureId()) ?? 0;
    }

    return (
        <div className="addon-status">
            {!addon.isQuotaBased() ?
                <div className="badge-wrapper">
                    {
                        addon.addonStatus !== AddonStatuses.Deactivated &&
                        <Badge type={AddonsStatusesLabelColorsMap[addon.addonStatus].badgeClass}
                               text={AddonsStatusesLabelColorsMap[addon.addonStatus].status}
                        />
                    }
                </div> :
                <div className="badge-wrapper">
                    {
                        (quotaFromAddon > 0) && (
                            (quotaFromPlan !== undefined && (quotaFromPlan ?? 0) > 0) ?
                                <Badge type={AddonsStatusesLabelColorsMap[AddonStatuses.InPlan].badgeClass}
                                       text={AddonsStatusesLabelColorsMap[AddonStatuses.InPlan].status}
                                />
                                :
                                <Badge type={AddonsStatusesLabelColorsMap[AddonStatuses.Active].badgeClass}
                                       text={AddonsStatusesLabelColorsMap[AddonStatuses.Active].status}
                                />
                        )
                    }
                </div>
            }
        </div>
    )
};

export default AddonStatus